import {observeSubtreeChanges} from 'lib/observeSubtreeChanges';

import {isOwnMarkMutation} from './annotationMarkElements';

type Handlers = Parameters<typeof observeSubtreeChanges>[1];
type Options = NonNullable<Parameters<typeof observeSubtreeChanges>[2]>;

/**
 * `observeSubtreeChanges` for an annotatable region: the region's own `<mark>` work
 * never counts as a change, so painting cannot trigger the repaint it came from.
 */
export function observeRegionChanges(
  target: Element,
  handlers: Handlers,
  options: Options = {}
): () => void {
  const {ignoreRecord} = options;
  return observeSubtreeChanges(target, handlers, {
    ...options,
    ignoreRecord: (record) => isOwnMarkMutation(record) || Boolean(ignoreRecord?.(record))
  });
}
